import { http } from "./http";

/** Contrato de GET /api/health — ver docs/API.md */
export interface HealthSnapshot {
  status: "ok" | "degraded";
  backend: boolean;
  database: boolean;
  timestamp: string;
  details?: {
    app: string;
    environment: string;
    queue: string;
    database: { connected: boolean; driver: string; latency_ms?: number; error?: string };
  };
}

export interface VersionInfo {
  api: string;
  php: string;
  laravel: string;
  stack: { backend: string; frontend: string; database: string };
}

export const healthService = {
  snapshot: () => http.get<HealthSnapshot>("/health"),
  version: () => http.get<VersionInfo>("/version"),
};
